// extracted by mini-css-extract-plugin
export default {"projectAnalytics":"ProjectAnalytics_projectAnalytics__Oy+-R","tableContainer":"ProjectAnalytics_tableContainer__1pdGW","dataTable":"ProjectAnalytics_dataTable__Eg-aS"};